export function setTime(time: string, date: Date = new Date()) {
  const newDate = new Date(date.toString());
  const [hours, minutes, seconds] = time.split(":");
  newDate.setHours(parseInt(hours) || 0);
  newDate.setMinutes(parseInt(minutes) || 0);
  newDate.setSeconds(parseInt(seconds) || 0);

  return newDate;
}

export function rentalDays(
  pickUp: number | Date | string,
  dropOff: number | Date | string
): number {
  const start = pickUp instanceof Date ? pickUp : new Date(pickUp);
  const end = dropOff instanceof Date ? dropOff : new Date(dropOff);
  const diffHours = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
  return Math.max(1, Math.ceil(diffHours / 24));
}
